<template>
  <settings-modal class="payment-reject-modal">
    <template slot="heading">Reject payment {{ payment.id }}?</template>

    <template v-if="isReturnReasonRequired">
      <v-select
        v-model="form.returnReason"
        class="payment-reject-modal__reason-select t-return-reason-select"
        :menu-props="{contentClass: 'payment-reject-modal__reason-select-menu'}"
        :items="returnReasonOptions"
        item-text="value"
        item-value="value"
        label="Reason for transaction return"
        :error-messages="getValidationErrorMessage('returnReason')"
      >
        <template
          slot="item"
          slot-scope="data"
        >
          <template>
            <v-list-tile-content>
              <v-list-tile-title>{{ data.item.value }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ data.item.name }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </template>
      </v-select>
    </template>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Data
  import sepaReturnReasons from '@/assets/data/sepa/return-reasons'
  import swiftReturnReasons from '@/assets/data/swift/return-reasons'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentRejectModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: { returnReason: undefined },
        rejectByAmlApiRequest: new ApiRequest(PaymentApi.rejectByAml)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      isSepaReturnReasonRequired () {
        return !this.payment.isInternalSender && this.payment.isSepaTransfer
      },
      isSwiftReturnReasonRequired () {
        return this.payment.hasFinTag
      },
      isReturnReasonRequired () {
        return this.isSepaReturnReasonRequired || this.isSwiftReturnReasonRequired
      },
      payment () {
        return this.modal.data.payment
      },
      returnReasonOptions () {
        let returnReasons = []

        if (this.isSepaReturnReasonRequired) {
          returnReasons = sepaReturnReasons
        }

        if (this.isSwiftReturnReasonRequired) {
          returnReasons = swiftReturnReasons
        }

        return Object.entries(returnReasons).map(([ code, reason ]) => ({
          name: reason,
          value: code
        }))
      },
      swiftReturnReasonOptions () {
        return Object.entries(swiftReturnReasons).map(([ code, reason ]) => ({
          name: reason,
          value: code
        }))
      },
      requiredFields () {
        const requiredFields = []

        if (this.isReturnReasonRequired) {
          requiredFields.push('returnReason')
        }

        return requiredFields
      },
      loading () {
        return this.rejectByAmlApiRequest.loading
      },
      error () {
        return this.rejectByAmlApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.rejectByAmlApiRequest
          .execute(this.payment.id, this.form)
          .then(() => {
            this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Payment has been successfully rejected.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      }
    }
  }
</script>

<style lang="scss">
  .payment-reject-modal {
    &.settings-modal {
      .container {
        padding-bottom: 28px;
      }
    }

    &__reason-select-menu {
      .v-list__tile {
        height: 52px;
      }
    }
  }
</style>
